module.exports = __webpack_public_path__ + "img/1f98a.7ecab08.svg";